import { g as a } from "./index-DUTDaDpU.mjs";
let o;
const r = async () => typeof globalThis > "u" ? !1 : (o === void 0 && (o = new Promise((t) => {
  const s = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", e = new XMLHttpRequest();
  e.timeout = 1e3, e.addEventListener("readystatechange", function() {
    e.readyState === XMLHttpRequest.DONE && t(e.status === 0 || e.responseURL !== s);
  }), e.open("HEAD", s, !0), e.send(null);
})), o);
function c(t, s) {
  return (/* @__PURE__ */ new Set(["0", "1"])).has(s) ? t : `${t}-${s}`;
}
let n;
async function g(t) {
  return n !== void 0 || (n = await r() ? Promise.resolve(void 0) : new Promise((e) => {
    setTimeout(() => {
      e(void 0);
    }, 5e3), a("get", t, "client_id", (i) => e(i));
  })), n;
}
export {
  c,
  r as d,
  g
};
//# sourceMappingURL=index-BbCEgNXO.mjs.map
